module.exports = __webpack_public_path__ + "assets/img/icon3.e46d5378.png";